import { render, staticRenderFns } from "./NewExternal.vue?vue&type=template&id=66014f4f&scoped=true"
import script from "./NewExternal.vue?vue&type=script&lang=js"
export * from "./NewExternal.vue?vue&type=script&lang=js"
import style0 from "./NewExternal.vue?vue&type=style&index=0&id=66014f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66014f4f",
  null
  
)

export default component.exports